// packages/ui/src/forms/unsavedChangesRegistry.ts
//
// How many unsaved-changes guards are armed on the page right now (`useUnsavedChangesNavigationGuard`
// with `enabled`, which `GuardedForm` and the editors use): what a reload the page starts by itself
// asks first (`useOlderReleaseRecovery`). A module, so it counts across the whole page.

let armed = 0;

/** Count one armed guard; the returned function disarms it (once). */
export function armUnsavedChanges(): () => void {
  armed += 1;
  let disarmed = false;
  return () => {
    if (disarmed) return;
    disarmed = true;
    armed -= 1;
  };
}

/** Whether any form on the page holds unsaved changes. */
export function hasUnsavedChanges(): boolean {
  return armed > 0;
}
